<template>
  <div id="app">
    <RequestProvider>
      <router-view :key="$route.fullPath" />
    </RequestProvider>
  </div>
</template>

<script>
import RequestProvider from './components/RequestProvider.vue';

export default {
  name: 'App',
  components: {
    RequestProvider
  }
};
</script>

<style>
</style>